import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cntt-user-not-found',
    template: 'Bạn chưa được cấp quyền để sử dụng hệ thống! Vui lòng liên hệ Admin cơ quan để được cấp quyền truy cập'
})
export class UserNotFoundComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login/usernotfound.component.ts